<template>
<b-container>
  <h2>27 Day Kp Forecast</h2>
  <p>This page shows a 27 day Kp forecast from the Space Weather Prediction Centre</p>
  <b-table hover :items="response" :fields="['date', 'value']">
    <template slot="value" slot-scope="data">
      <span :style="'color: ' + data.item.color">{{ data.value }}</span>
    </template>
  </b-table>
</b-container>
</template>

<script>
import {
  get
} from 'lodash'
import {
  DateTime
} from 'luxon'

import axios from 'axios'

export default {
  name: 'kp27day',
  mounted() {
    axios.post('https://v2.api.auroras.live/', {
        "modules": ['kp.27day'],
        "format": {
          "date": {
            "tz": (window.localStorage.getItem('auroraslive-tz') || (new Date).getTimezoneOffset()),
            "format": "D M jS Y"
          },
          "color": {
            "format": "hex"
          }
        }
      }, {
        withCredentials: true //correct
      })
      .then(function(response) {
        this.response = response.data["kp.27day"]
      }.bind(this))
      .catch(function() {
        this.error = "There was an error loading the data. The error returned was " + this.error
      }.bind(this))
      .then(function() {
        this.appdata.loading = false
      }.bind(this))
  },
  data() {
    return {
      response: [],
      ld: {
        get: _.get
      },
      DateTime: DateTime,
      appdata: {
        loading: false
      }
    }
  }
}
</script>
